"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1939],{

/***/ 11939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WindowDomain": function() { return /* binding */ WindowDomain; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var _create_super = __webpack_require__(39309);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/_domain/Domain.ts

var Domain = /*#__PURE__*/ function() {
    "use strict";
    function Domain() {
        (0,_class_call_check/* default */.Z)(this, Domain);
    }
    var _proto = Domain.prototype;
    _proto.host = function host() {
        var url = this.url();
        return [
            undefined,
            url.host
        ];
    };
    return Domain;
}();

;// CONCATENATED MODULE: ../../packages/stayforlong/src/_domain/WindowDomain.ts




var WindowDomain = /*#__PURE__*/ function(Domain) {
    "use strict";
    (0,_inherits/* default */.Z)(WindowDomain, Domain);
    var _super = (0,_create_super/* default */.Z)(WindowDomain);
    function WindowDomain(config) {
        (0,_class_call_check/* default */.Z)(this, WindowDomain);
        var _this;
        _this = _super.call(this);
        _this.config = config;
        return _this;
    }
    var _proto = WindowDomain.prototype;
    _proto.url = function url() {
        return new URL(window.location.href);
    };
    WindowDomain.create = function create(param) {
        var config = param.config;
        return new WindowDomain(config);
    };
    return WindowDomain;
}(Domain);


/***/ })

}]);